import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { getUserDatabase } from './getUserDatabase';

export async function addFoodItemToDatabase(user, item) {
  if (!user?.uid || !item?.containerKey) {
    return null;
  }

  const userDatabase = await getUserDatabase(user);
  const containers = userDatabase?.containers ?? {};
  const containerItems = Array.isArray(containers[item.containerKey])
    ? containers[item.containerKey]
    : [];

  const nextDatabase = {
    ...userDatabase,
    containers: {
      ...containers,
      [item.containerKey]: [
        ...containerItems,
        {
          id: item.id,
          name: item.name,
          quantity: item.quantity,
          expirationDate: item.expirationDate,
        },
      ],
    },
  };

  await setDoc(doc(db, 'users', user.uid), nextDatabase, { merge: true });

  return nextDatabase;
}
